import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { DataAnamolyService } from './dataanamoly.service';
import { DataAnalomy } from './model/dataanamoly';
import { DataAnalomyRequest } from './model/dataanamolyRequest';
import { ToasterService } from 'angular2-toaster/src/toaster.service';

@Component({
    templateUrl: 'dataanamoly.component.html'
})
export class DataAnamolyComponent implements OnInit {
    dataAnamolies: DataAnalomy[];
    filteredDataAnamolies: DataAnalomy[];

    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    disabled = false;
    statusViewType = 'View All';
    sortType = 'Date';
    dateRange = 0;
    date1: Date;



    constructor( private toasterService: ToasterService,
        private dataAnamolyService: DataAnamolyService
    ) { }


    getDataAnamoly(dateFrom: string, dateTo: string) {
        this.submitting = true;
        this.dataAnamolyService.getWikiAnamoly(dateFrom, dateTo)
            .then(res => {
                this.dataAnamolies = res.anomalies;
                this.clickViewType(event);
                this.clickSortType(event);

            })
            .catch(error => {
                this.errorHandler(error);
            });
    }


    ngOnInit() {
        {
            const date = new Date();
            //console.log(date.getHours());

            date.setDate(date.getDate() - 1);
            this.dateFormatter(date);
            // this.getDataAnamoly(this.dateFormatter(date), this.dateFormatter(date)
            // );
        }
    }


    clickViewType(event: any) {
        if (this.statusViewType == 'View All') {
            this.filteredDataAnamolies = this.dataAnamolies;
        } else if (this.statusViewType == 'View Approved') {
            this.filteredDataAnamolies = this.dataAnamolies.filter(c => c.state == 'approved');
        }
        else if (this.statusViewType == 'View Accepted') {
            this.filteredDataAnamolies = this.dataAnamolies.filter(c => c.state == 'accepted');
        }
        else if (this.statusViewType == 'View Rejected') {
            this.filteredDataAnamolies = this.dataAnamolies.filter(c => c.state == 'rejected');
        }
        else if (this.statusViewType == 'View Unexplained') {
            this.filteredDataAnamolies = this.dataAnamolies.filter(c => c.state == 'unexplained');
        }
        else if (this.statusViewType == 'View Override') {
            this.filteredDataAnamolies = this.dataAnamolies.filter(c => c.state == 'override');
        }
        else {
            this.filteredDataAnamolies = this.dataAnamolies.filter(c => c.state == 'normal');
        }
    }

    clickSortType(event: any) {
        if (this.sortType == 'Date') {
            this.filteredDataAnamolies.sort((a, b) => new Date(b.source_event_date).getTime() - new Date(a.source_event_date).getTime());

        } else if (this.sortType == 'Title') {
            this.filteredDataAnamolies.sort((leftSide, rightSide): number => {
                if (leftSide.content_name > rightSide.content_name) { return 1; };
                if (leftSide.content_name < rightSide.content_name) { return -1; };
                return 0;
            });
        } else if (this.sortType == 'Source') {
            this.filteredDataAnamolies.sort((leftSide, rightSide): number => {
                if (leftSide.source > rightSide.source) { return 1; };
                if (leftSide.source < rightSide.source) { return -1; };
                return 0;
            });
        } else if (this.sortType == 'Type') {
            this.filteredDataAnamolies.sort((leftSide, rightSide): number => {
                if (leftSide.source_event_type > rightSide.source_event_type) { return 1; };
                if (leftSide.source_event_type < rightSide.source_event_type) { return -1; };
                return 0;
            });
        } else if (this.sortType == 'Category') {
            this.filteredDataAnamolies.sort((leftSide, rightSide): number => {
                if (leftSide.source_category > rightSide.source_category) { return 1; };
                if (leftSide.source_category < rightSide.source_category) { return -1; };
                return 0;
            });
        } else if (this.sortType == 'Language') {
            this.filteredDataAnamolies.sort((leftSide, rightSide): number => {
                if (leftSide.language > rightSide.content_name) { return 1; };
                if (leftSide.language < rightSide.language) { return -1; };
                return 0;
            });
        } else if (this.sortType == 'Status') {
            this.filteredDataAnamolies.sort((leftSide, rightSide): number => {
                if (leftSide.state > rightSide.state) { return 1; };
                if (leftSide.state < rightSide.state) { return -1; };
                return 0;
            });
        }
    }


    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    clickDateRange(range: number) {

        this.filteredDataAnamolies = undefined;
        this.dateRange = range;
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);
        const rawDate = new Date();
        rawDate.setDate(currentDate.getDate() - range);
        // this.getDataAnamoly(this.dateFormatter(rawDate), this.dateFormatter(currentDate));
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        this.notificationContent = error;
        this.createNotification();
    }

    dateFormatter(dateInput: Date) {
        const rawmonth = dateInput.getUTCMonth() + 1;
        const rawday = dateInput.getUTCDate();
        let month = rawmonth.toString();
        if (month.length == 1) {
            month = '0' + month;
        }
        let day = rawday.toString();
        if (day.length == 1) {
            day = '0' + day;
        }
        const year = dateInput.getUTCFullYear().toString();
        const formattedDate = year + '-' + month + '-' + day;
        return formattedDate;
    }

    openTitle(dataAnamoly: DataAnalomy) {
        const newWindow = window.open('https://www.google.co.nz/search?q=' + dataAnamoly.content_name + '&tbm=nws');


        return newWindow;
    }

    clickOverride(id: string) {
        if (this.disabled == false) {

            const elementId = 'override-' + id;
            document.getElementById(elementId).style.display = 'flex';
            document.getElementById(elementId).style.width = '139px';
        }
    }

    clickSaveOverride(id: string, dataAnamoly: DataAnalomy, value: any) {
        if (this.disabled == false) {

            this.disabled = true;
            const elementId = 'override-' + id;
            document.getElementById(elementId).style.display = 'none';
            if (value != '') {
                dataAnamoly.state = 'override';
                dataAnamoly.adjusted_value = +value;
                this.updateAnamoly(dataAnamoly);
            }
        }
    }

    clickApprove(dataAnamoly: DataAnalomy) {
        if (this.disabled == false) {
            this.disabled = true;
            dataAnamoly.state = 'approved';
            this.updateAnamoly(dataAnamoly);
        }
    }

    clickReject(dataAnamoly: DataAnalomy) {
        if (this.disabled == false) {

            this.disabled = true;
            dataAnamoly.state = 'rejected';
            this.updateAnamoly(dataAnamoly);
        }
    }

    mouseLeaveOverride(id: string) {
        const elementId = 'override-' + id;
        document.getElementById(elementId).style.display = 'none';
    }

    updateAnamoly(dataAnamoly: DataAnalomy) {

        const anomalyRequest = new DataAnalomyRequest();
        anomalyRequest.tosave.push(dataAnamoly);
        this.dataAnamolyService.updateAnamoly(anomalyRequest)
            .then(res => {
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = 'Title : ' + dataAnamoly.content_name + ' state updated succesfully to : ' + dataAnamoly.state;
                this.createNotification();
                this.disabled = false;

            })
            .catch(error => {
                this.errorHandler(error);
                this.filteredDataAnamolies = [];
                const date = new Date();
                date.setDate(date.getDate() - 1);
                this.dateFormatter(date);
                // this.getDataAnamoly(this.dateFormatter(date), this.dateFormatter(date));
                this.disabled = false;

            });

    }
}




// WEBPACK FOOTER //
// ./src/app/catalogue/dataanamoly/dataanamoly.component.ts